import { Box, styled, Typography } from '@sb/cc-design-system';

export const AccordionItemContent = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const AccordionItemLabel = styled(Typography)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AccordionItemActions = styled(Box)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ProductLineupAccordionWrapper = styled(Box)`
  width: 100%;
`;
